// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import receptionStatusEntity from './entities/reception-status.json';
import receptionStatusMenu from '../pages/reception-status/menu.json';
import receptionStatusFullForm from '../pages/reception-status/forms/full.json';
import receptionStatusContextForm from '../pages/reception-status/forms/context.json';
import receptionStatusMiniForm from '../pages/reception-status/forms/mini.json';
import receptionStatusLookupForm from '../pages/reception-status/forms/lookup.json';
import receptionStatusTableView from '../pages/reception-status/views/table.json';
import receptionStatusDashboardView from '../pages/reception-status/views/dashboard.json';

/** Тип запису «Статус прийому» зі сторінками пакета: меню, форми та подання з pages/reception-status/. */
export const receptionStatusDefinition: IRecordTypeDefinition = {
  ...receptionStatusEntity,
  views: assembleViewSet({
      table: receptionStatusTableView,
      dashboard: receptionStatusDashboardView,
  }),
  form: receptionStatusFullForm,
  forms: { full: receptionStatusFullForm, context: receptionStatusContextForm, mini: receptionStatusMiniForm, lookup: receptionStatusLookupForm },
  menu: receptionStatusMenu,
} as IRecordTypeDefinition;
